import React, { useState, useEffect } from 'react';
import {
  Autocomplete,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Card,
  FormControlLabel,
  Typography,
  FormControl,
  Grid,
  Checkbox,
} from '@mui/material';
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useForm, Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import GoldPrice2Form from './GoldPrice2Form';
import { ImageUpload } from '../../ImageUpload';

// Set Thai locale for dayjs
dayjs.locale('th');

// Utility functions
const formatNumber = (value) => {
  if (!value) return '';
  return Number(value).toLocaleString();
};

const parseNumber = (value) => {
  if (!value) return 0;
  return Number(value.toString().replace(/,/g, ''));
};

const NumberField = ({ label, field, ...props }) => {
  const [displayValue, setDisplayValue] = useState(formatNumber(field.value));

  useEffect(() => {
    setDisplayValue(formatNumber(field.value));
  }, [field.value]);

  const handleChange = (e) => {
    const inputValue = e.target.value;

    // อนุญาตให้พิมพ์ตัวเลข คอมม่า และจุดทศนิยม
    if (inputValue === '' || /^[\d,]*\.?\d*$/.test(inputValue)) {
      setDisplayValue(inputValue);

      // แปลงกลับเป็นตัวเลขเพื่อเก็บใน form
      const numValue = parseNumber(inputValue);
      field.onChange(numValue);
    }
  };

  const handleBlur = () => {
    // จัดรูปแบบใหม่เมื่อออกจาก field
    const formatted = formatNumber(field.value);
    setDisplayValue(formatted);
  };

  return (
    <TextField
      {...props}
      label={label}
      type="text"
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
      sx={{
        '& .MuiOutlinedInput-root': {
          '& fieldset': { borderColor: 'black' },
          '&:hover fieldset': { borderColor: 'black' },
          '&.Mui-focused fieldset': { borderColor: 'black' },
        },
        '& label.Mui-focused': { color: 'black' },
      }}
      variant="outlined"
      fullWidth
    />
  );
};

export function AddProductform({
  listorder,
  material,
  setListorder,
  place,
  placeName,
  setPlace,
  me,
  transactionDate,
  setTransactionDate,
  setPayment,
  setTotalListOrder,
  noMaterial,
  materialTypeName,
  materialTypeVat,
  setMaterialName,
  setMaterialUnit,
  materialTypeId,
  setmaterialTypeId,
  setNoMaterial,
  setmaterialTypeName,
  setmaterialTypeVat,
  goldPrice,
  noteMaterial,
  setNoteMaterial,
  bank,
  image,
  setImage,
  cashList,
}) {
  const resetValues = {
    quantity: 1,
    material: null,
    place: null,
    cashStatus: false,
    creditStatus: false,
    transferStatus: false,
    cashAmount: 0,
    credit: 0,
    tranfer: 0,
    price: 0,
    cost: 0,
    weight: 0,
    materialType: null,
    lot_number: '',
    transaction_date: dayjs(), // Add default date (today)
  };

  const [reload, setReload] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [showGoldAlert, setShowGoldAlert] = useState(false);
  const [pendingProduct, setPendingProduct] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({
    material: false,
    place: false,
    materialType: false,
    cash: false,
    transfer: false,
    credit: false,
    note: false,
  });

  const bankList = _.filter(bank, (b) => b.isCash === false && b.hide !== true);

  const GoldSellBar =
    parseFloat((goldPrice?.price?.gold_bar?.sell || '').replace(/,/g, '')) *
    0.95;

  const GoldBuyBar = parseFloat(
    (goldPrice?.price?.gold_bar?.buy || '').replace(/,/g, ''),
  );

  const { control, watch, setValue, reset, getValues, handleSubmit } = useForm({
    defaultValues: {
      use_full_price: false,
      price_gold: GoldSellBar,
      transaction_date: dayjs(),
    },
  });

  const selectedBank = watch('transfer.bank');
  const transferAmount = Number(watch('transfer.amount') || 0);
  const cashAmount = Number(watch('cash.amount') || 0);

  const totalCostListOrder = _.sumBy(
    listorder,
    (item) => Number(item.cost) || 0,
  );
  const remain =
    totalCostListOrder -
    (Number(watch('cash.amount')) || 0) -
    (Number(watch('transfer.amount')) || 0) -
    (Number(watch('credit.amount')) || 0);

  useEffect(() => {
    setValue('price_gold', GoldSellBar);
  }, [GoldSellBar, setValue]);

  useEffect(() => {
    setTotalListOrder(totalCostListOrder);
  }, [totalCostListOrder, setTotalListOrder]);

  useEffect(() => {
    setPayment({
      cashStatus: selectedOptions.cash,
      cash: getValues('cash.amount') || 0,
      credit: getValues('credit.amount') || 0,
      creditStatus: selectedOptions.credit || false,
      transfer: getValues('transfer.amount') || 0,
      transferStatus: selectedOptions.transfer || false,
      bank: getValues('transfer.bank') || '',
    });
  }, [watch('cash.amount'), watch('transfer.amount'), watch('credit.amount')]);
  // useEffect(() => {
  //   // ถ้าเลือกธนาคารอยู่ และเงินไม่พอ → เคลียร์ธนาคารออกจากฟอร์ม
  //   if (selectedBank && bankCurrent < remain) {
  //     setValue('transfer.bank', null);

  //     // แจ้งเตือน
  //     alert(
  //       `ยอดเงินในบัญชี ${
  //         selectedBank.bankName
  //       } ไม่เพียงพอ (คงเหลือ ${bankCurrent.toLocaleString()} บาท)`,
  //     );
  //   }
  // }, [remain, selectedBank]);
  const handleOptionChange = (event) => {
    const { name, checked } = event.target;
    setSelectedOptions((prev) => ({ ...prev, [name]: checked }));
  };

  const handleContinueAlert = () => {
    setShowGoldAlert(false);
    if (pendingProduct) {
      if (listorder.length > 10) {
        window.alert('ไม่สามารถเพิ่ม order ได้เกิน 10 รายการ');
        setPendingProduct(null);
        return;
      }
      listorder.push(pendingProduct);
      setListorder(listorder);
      setPendingProduct(null);
      resetForm();
    }
  };

  const resetForm = () => {
    reset({ ...resetValues, material: null, transaction_date: dayjs() });
    setValue('price_gold', GoldSellBar);
    setSelectedOptions({
      material: false,
      cash: false,
      transfer: false,
      credit: false,
      note: false,
    });
    setResetKey((prev) => prev + 1);
  };

  const handleRemoveMaterial = (index) => {
    listorder.splice(index, 1);
    setListorder(listorder);
    setReload(!reload);
  };

  const checkPlaceName = (option) => {
    const mapping = {
      คลังรูปพรรณเก่า: 'เก่า',
      คลังรูปพรรณใหม่: 'ใหม่',
    };
    return mapping[option?.place?.name] || ' คลังอื่นๆ';
  };

  const handleAddProduct = () => {
    const values = getValues();
    if (
      !values.material ||
      !values.quantity ||
      !values.weight ||
      !values.cost
    ) {
      window.alert('กรุณาใส่ข้อมูลให้ครบถ้วน');
      return;
    }

    const costPrice = Number(values.cost) || 0;

    let imageData = null;
    if (!_.isEmpty(image) && image?.[0]?.data_url) {
      imageData = {
        image: image[0].data_url,
        imageType: 'orderImage',
        alt: '',
      };
    }

    const data = {
      material: values.material?._id,
      materialname: values.material?.name,
      materialunit: values.material?.unit,
      isGold_bar: values.material?.isbar,
      note: values.note || '',
      materialTypeId: materialTypeId,
      nomaterial: noMaterial || false,
      materialTypeName: materialTypeName,
      materialTypeVat: materialTypeVat,
      place: placeName,
      lot_number: values.lot_number || '',
      gold_official: Number(GoldBuyBar) || 0,
      weight: values.weight,
      quantity: values.quantity,
      cost: values.cost || 0,
      price_gold: Number(values.price_gold) || 0,
      transaction_date: values.transaction_date
        ? values.transaction_date.format('YYYY-MM-DD')
        : dayjs().format('YYYY-MM-DD'),
      ...(imageData && { image: imageData }),
    };

    const currentGoldPrice = Number(values.price_gold) || 0;
    const currentWeight = Number(values.weight) || 0;

    if (costPrice < (currentGoldPrice / 15.16) * currentWeight) {
      setPendingProduct(data);
      setShowGoldAlert(true);
      return;
    }
    if (listorder.length >= 10) {
      window.alert('ไม่สามารถเพิ่ม order ได้เกิน 10 รายการ');
      return; // ❗ไม่ reset
    }

    setListorder((prev) => [...prev, data]);
    resetForm();
  };

  // if (listorder.length >= 10) {
  //   window.alert('ไม่สามารถเพิ่ม order ได้เกิน 10 รายการ');
  //   return;
  // }
  const renderAddProductForm = () => (
    <Card>
      <form onSubmit={handleSubmit(handleAddProduct)}>
        <div className="px-6 pt-4">
          <Typography variant="h6" gutterBottom>
            <div className="font-bold text-xl text-red-600 pl-2">
              เพิ่มสินค้าที่ซื้อ
            </div>
          </Typography>

          <div className="py-2">
            <FormControl fullWidth>
              <Controller
                key={resetKey}
                name="material"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    fullWidth
                    options={material?.rows || []}
                    getOptionLabel={(option) =>
                      `${option?.name}${checkPlaceName(option)} (${
                        option?.material_type?.name
                      })`
                    }
                    onChange={(e, value) => {
                      field.onChange(value);
                      setMaterialName(value?.name);
                      setmaterialTypeName(value?.material_type?.name);
                      setmaterialTypeVat(value?.material_type?.vat);
                      setmaterialTypeId(value?.material_type?._id);
                      setPlace(value?.place.name);
                      setNoMaterial(value?._id);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        label="สินค้า"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: 'black' },
                            '&:hover fieldset': { borderColor: 'black' },
                            '&.Mui-focused fieldset': { borderColor: 'black' },
                          },
                          '& label.Mui-focused': { color: 'black' },
                        }}
                      />
                    )}
                  />
                )}
              />
            </FormControl>

            <div className="flex items-center space-x-2 mt-3">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedOptions.note}
                    onChange={handleOptionChange}
                    name="note"
                  />
                }
                label="หมายเหตุ"
              />
              {selectedOptions.note && (
                <div className="w-1/2">
                  <Controller
                    control={control}
                    name="note"
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        variant="outlined"
                        size="small"
                        sx={{
                          mt: 1,
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: 'black' },
                            '&:hover fieldset': { borderColor: 'black' },
                            '&.Mui-focused fieldset': { borderColor: 'black' },
                          },
                          '& label.Mui-focused': { color: 'black' },
                        }}
                        onChange={(e) => {
                          field.onChange(e);
                          setNoteMaterial(e.target.value);
                        }}
                      />
                    )}
                  />
                </div>
              )}
            </div>
          </div>

          {placeName === 'คลังอื่นๆ' ? (
            <div className="grid grid-cols-2 gap-2">
              <Controller
                name="weight"
                control={control}
                render={({ field }) => (
                  <NumberField label="จำนวน (ชิ้น)" field={field} />
                )}
              />
            </div>
          ) : (
            <div className="grid grid-cols-2 gap-2">
              <Controller
                name="weight"
                control={control}
                render={({ field }) => (
                  <NumberField label="น้ำหนัก(กรัม)" field={field} />
                )}
              />
              <Controller
                name="quantity"
                control={control}
                defaultValue={1}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="จำนวน"
                    type="number"
                    InputProps={{ readOnly: true }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: 'black' },
                        '&:hover fieldset': { borderColor: 'black' },
                        '&.Mui-focused fieldset': { borderColor: 'black' },
                      },
                      '& label.Mui-focused': { color: 'black' },
                    }}
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </div>
          )}

          <div className="grid grid-cols-2 gap-2 py-3">
            <Controller
              name="cost"
              control={control}
              render={({ field }) => (
                <NumberField label="มูลค่า" field={field} />
              )}
            />
            {placeName === 'คลังอื่นๆ' ? (
              <Controller
                name="price_gold"
                control={control}
                render={({ field }) => (
                  <NumberField label="ราคาทอง" field={field} />
                )}
              />
            ) : (
              <Controller
                name="price_gold"
                control={control}
                render={({ field }) => (
                  <NumberField label="ราคาทอง" field={field} />
                )}
              />
            )}
          </div>

          <div className="w-full px-1 py-2">
            <ImageUpload images={image} maxNumber={1} setImages={setImage} />
          </div>

          <div className="py-2 text-center">
            <Button
              variant="contained"
              color="error"
              type="button"
              sx={{ fontSize: '1.2rem', padding: '14px 28px' }}
              onClick={handleAddProduct}
              disabled={listorder.length >= 10}
            >
              เพิ่มสินค้าที่ซื้อ
            </Button>
          </div>
        </div>
      </form>
    </Card>
  );

  const renderOrderList = () => (
    <div className="md:px-6 xl:pt-4">
      <div className="text-xl text-center pb-1">รายการสินค้าที่ซื้อ</div>
      <Card>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {[
                  'ลำดับ',
                  'ชื่อสินค้า',
                  'คลังสินค้า',
                  'น้ำหนัก(กรัม)',
                  'จำนวน',
                  'มูลค่า(บาท)',
                  'วันที่',
                  'ดำเนินการ',
                ].map((header) => (
                  <TableCell
                    key={header}
                    align="center"
                    style={{ backgroundColor: '#f5f5f5' }}
                  >
                    <div className="text-black">{header}</div>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {!_.isEmpty(listorder) ? (
                listorder.map((product, index) => {
                  const findMaterial = _.find(material?.rows, {
                    _id: product?.material,
                  });
                  return (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>
                        <div>{findMaterial?.name}</div>
                        <span>({findMaterial?.material_type?.name})</span>
                      </TableCell>
                      <TableCell>{findMaterial?.place?.name}</TableCell>
                      <TableCell>
                        {findMaterial?.place?.name === 'คลังอื่นๆ'
                          ? '-'
                          : formatNumber(product?.weight)}
                      </TableCell>
                      <TableCell>{formatNumber(product?.quantity)}</TableCell>
                      <TableCell>{formatNumber(product?.cost)} บาท</TableCell>
                      <TableCell>
                        {transactionDate
                          ? dayjs(transactionDate).format('DD/MM/YYYY')
                          : dayjs().format('DD/MM/YYYY')}
                      </TableCell>
                      <TableCell>
                        <Button
                          color="error"
                          variant="contained"
                          size="small"
                          onClick={() => handleRemoveMaterial(index)}
                        >
                          ลบ
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={8}>
                    <div className="text-center">ไม่มีข้อมูล</div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <div className="text-center p-2">
          ยอดรวม {formatNumber(totalCostListOrder) || 0} บาท
        </div>
      </Card>
    </div>
  );

  const renderPaymentForm = () => (
    <div className="xl:pl-6">
      <Card>
        <div className="p-2 items-center text-center">
          <FormControl
            component="fieldset"
            sx={{ display: 'flex', justify: 'center', width: '100%' }}
          >
            <Typography variant="h6" align="center" gutterBottom>
              เลือกการชำระเงิน
            </Typography>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedOptions.cash}
                      onChange={handleOptionChange}
                      name="cash"
                      disabled={
                        remain > (cashList?.[0]?.currentAmount || 0) ||
                        cashAmount > (cashList?.[0]?.currentAmount || 0)
                      } // ⭐⭐⭐ Disable เงินสด
                    />
                  }
                  label={`เงินสด (คงเหลือ ${
                    cashList?.[0]?.currentAmount?.toLocaleString() || 0
                  } บาท)`}
                />

                {selectedOptions.cash && (
                  <Controller
                    control={control}
                    name="cash.amount"
                    render={({ field }) => (
                      <NumberField label="จำนวนเงิน" field={field} />
                    )}
                  />
                )}
              </Grid>

              <Grid item xs={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedOptions.transfer}
                      onChange={handleOptionChange}
                      name="transfer"
                    />
                  }
                  label="โอนเงิน"
                />
                {selectedOptions.transfer && (
                  <>
                    <Controller
                      control={control}
                      name="transfer.bank"
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          options={bankList}
                          getOptionLabel={(option) =>
                            `${option.bankName} (${option.accountNumber}) - ${option.name}`
                          }
                          // ⭐⭐ Disable เมื่อ currentAmount < remain
                          getOptionDisabled={(option) =>
                            option.currentAmount < remain ||
                            option.currentAmount < transferAmount
                          }
                          onChange={(_, data) => field.onChange(data)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="เลือกบัญชีธนาคาร"
                              variant="outlined"
                              size="small"
                              fullWidth
                              sx={{ mt: 1 }}
                            />
                          )}
                          isOptionEqualToValue={(option, value) =>
                            option._id === value?._id
                          }
                        />
                      )}
                    />

                    <Controller
                      control={control}
                      name="transfer.amount"
                      render={({ field }) => (
                        <NumberField label="จำนวนเงิน" field={field} />
                      )}
                    />
                  </>
                )}
              </Grid>

              <Grid item xs={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedOptions.credit}
                      onChange={handleOptionChange}
                      name="credit"
                    />
                  }
                  label="เครดิต"
                />
                {selectedOptions.credit && (
                  <Controller
                    control={control}
                    name="credit.amount"
                    render={({ field }) => (
                      <NumberField label="จำนวนเงิน" field={field} />
                    )}
                  />
                )}
              </Grid>
            </Grid>

            <div
              className={`font-bold text-lg ${
                remain < 0 ? 'text-green-600' : 'text-red-600'
              }`}
            >
              {remain < 0 ? (
                <div>จ่ายเงินเกิน {formatNumber(Math.abs(remain))} บาท</div>
              ) : remain === 0 ? (
                <div className="text-green-600">ชำระเงินครบถ้วน</div>
              ) : (
                <div>ต้องจ่ายอีก {formatNumber(remain)} บาท</div>
              )}
            </div>
          </FormControl>
        </div>
      </Card>
    </div>
  );

  // ช่วยฟังก์ชันเพิ่ม
  const isToday = (d) => dayjs.isDayjs(d) && d.isSame(dayjs(), 'day');

  // ฟังก์ชันเช็กช่วงห้าม
  const isForbidden = (d) => {
    if (!d || !dayjs.isDayjs(d) || !d.isValid()) return false;
    const h = d.hour();
    const m = d.minute();

    if (isToday(d)) {
      // วันนี้: ห้าม 23:30–00:30 (เหมือนเดิม)
      const inLateWindow = h === 23 && m >= 30; // 23:30–23:59
      const inEarlyWindow = h === 0 && m <= 30; // 00:00–00:30
      return inLateWindow || inEarlyWindow;
    }

    // ไม่ใช่วันนี้: อนุญาตเฉพาะ 07:00–23:30
    if (h < 7) return true; // ก่อน 07:00
    if (h > 23) return true; // เลย 23 ชั่วโมง (กรณีแปลก)
    if (h === 23 && m > 30) return true; // หลัง 23:30
    return false;
  };

  // (ทางเลือก) เลื่อนเวลาให้อยู่ในช่วงอนุญาตอัตโนมัติ
  const snapToAllowed = (d) => {
    if (!d || !dayjs.isDayjs(d) || !d.isValid()) return d;
    if (!isForbidden(d)) return d;

    const h = d.hour();
    const m = d.minute();

    if (isToday(d)) {
      // วันนี้: ถ้าอยู่ฝั่งก่อนเที่ยงคืนให้ snap เป็น 23:29:59, ถ้าหลังเที่ยงคืนให้ 00:31:00
      if (h === 23) return d.minute(29).second(59);
      return d.hour(0).minute(31).second(0);
    } else {
      // ไม่ใช่วันนี้: บังคับอยู่ใน 07:00–23:30
      if (h < 7) return d.hour(7).minute(0).second(0);
      if (h > 23 || (h === 23 && m > 30))
        return d.hour(23).minute(30).second(0);
      return d; // เผื่อกรณีอื่น
    }
  };

  return (
    <div className="container mx-auto">
      {showGoldAlert && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
          <div className="bg-white p-6 rounded shadow-lg text-center">
            <div className="mb-4 text-lg font-bold text-red-600">
              ราคาทองคำที่ซื้อ {formatNumber(getValues('cost'))} บาท
              ต่ำกว่าราคาทองต่อกรัม{' '}
              {Number(
                (getValues('price_gold') / 15.16) * getValues('weight'),
              )?.toLocaleString('th-TH', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3,
              })}{' '}
              บาท
            </div>
            <Button
              variant="contained"
              color="primary"
              onClick={handleContinueAlert}
            >
              ทำรายการต่อ
            </Button>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <div className="space-y-6">
          <div className="rounded-lg w-full px-4 pt-2">
            <GoldPrice2Form buy={true} />
          </div>
          {me?.userData?.department?.access?.OTHER?.dateBuy && (
            <div className="bg-white rounded-lg p-4">
              <div className="flex items-center justify-between">
                <Typography variant="h6" className="text-nowrap">
                  วันที่ทำรายการ
                </Typography>
                <div>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDateTimePicker
                      label="วันที่และเวลาทำรายการ"
                      value={transactionDate}
                      onChange={(newValue) => {
                        if (
                          !newValue ||
                          !dayjs.isDayjs(newValue) ||
                          !newValue.isValid()
                        ) {
                          setTransactionDate(newValue);
                          return;
                        }
                        const snapped = snapToAllowed(newValue);

                        if (isForbidden(newValue)) {
                          alert(
                            isToday(newValue)
                              ? 'ระบบปรับเวลาให้อยู่ในช่วงที่อนุญาต (วันนี้ห้าม 23:30–00:30)'
                              : 'ระบบปรับเวลาให้อยู่ในช่วงที่อนุญาต (สำหรับวันที่ไม่ใช่วันนี้ เลือกได้เฉพาะ 07:00–23:30)',
                          );
                        }
                        setTransactionDate(snapped);
                      }}
                      format="DD/MM/YYYY HH:mm"
                      shouldDisableTime={(timeValue, view) => {
                        if (!timeValue || !dayjs.isDayjs(timeValue))
                          return false;

                        const thisIsToday = isToday(timeValue);
                        const h = timeValue.hour();
                        const m = timeValue.minute();

                        if (view === 'hours') {
                          if (!thisIsToday) {
                            // ไม่ใช่วันนี้: เปิดเฉพาะชั่วโมง 7..23
                            return h < 7 || h > 23;
                          }
                          // วันนี้: ไม่ปิดชั่วโมง (ให้ไปคุมระดับนาทีแทน)
                          return false;
                        }

                        if (view === 'minutes') {
                          if (!thisIsToday) {
                            // ไม่ใช่วันนี้: นาทีห้ามก่อน 07:00 และหลัง 23:30
                            if (h < 7) return true;
                            if (h === 23 && m > 30) return true;
                            if (h > 23) return true;
                            return false;
                          }
                          // วันนี้: ใช้กฎเดิมห้าม 23:30–00:30
                          return isForbidden(timeValue);
                        }

                        return false;
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          sx={{
                            width: 250,
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': { borderColor: 'black' },
                              '&:hover fieldset': { borderColor: 'black' },
                              '&.Mui-focused fieldset': {
                                borderColor: 'black',
                              },
                            },
                            '& label.Mui-focused': { color: 'black' },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </div>
              </div>
            </div>
          )}
          <div className="rounded-lg w-full">{renderAddProductForm()}</div>
        </div>
        <div className="bg-white rounded-lg w-full xl:mb-6 mt-2 py-4">
          {renderOrderList()}
        </div>
      </div>

      {!_.isEmpty(listorder) && (
        <div className="bg-white rounded-lg w-full xl:mb-6 mt-2 py-4">
          {renderPaymentForm()}
        </div>
      )}
    </div>
  );
}

AddProductform.propTypes = {
  material: PropTypes.object,
  selectMaterial: PropTypes.object,
  setSelectMaterial: PropTypes.func,
  materialType: PropTypes.arrayOf(PropTypes.object),
  image: PropTypes.arrayOf(PropTypes.object),
  setImage: PropTypes.func,
};

AddProductform.defaultProps = {
  material: null,
  selectMaterial: null,
};

export default AddProductform;
